<template>
  <div class="BindCard">
    <div class="BindCard-background">
      <div class="NewCape-AppTitle">
        <img src="../../public/obraoag/NewCapeReturn.png" alt="" @click="BackLevel()">
        绑定新卡
      </div>
      <div class="BindCard-binding">
        <div class="BindCard-CardNumber">
          <span>卡号 :</span>
          <el-input v-model="BiCardNum" placeholder="请输入卡号" clearable @input="BiCardber()"></el-input>
        </div>
        <div class="BindCard-CardNumber">
          <span>卡初始密码 :</span>
          <el-input v-model="BiCarmHael" placeholder="请输入密码" clearable show-password @input="BiCarmChel()"></el-input>
        </div>
      </div>
      <button class="BindCard-confirm" @click="bindconm()">确认</button>
    </div>
    <!-- 失败提示 -->
    <div id="warnToast" :style="'display:' + bindfail">
      <div class="weui-mask_transparent"></div>
      <div class="weui-toast">
        <i class="weui-icon-warn weui-icon_toast"></i>
        <p class="weui-toast__content">{{bindtips}}</p>
      </div>
    </div>
    <!-- 成功提示 -->
    <div id="toast" :style="'display:' + bindsucs">
      <div class="weui-mask_transparent"></div>
      <div class="weui-toast">
        <i class="weui-icon-success-no-circle weui-icon_toast"></i>
        <p class="weui-toast__content">{{bindtips}}</p>
      </div>
    </div>
    <TextTips></TextTips>
  </div>
</template>

<script>
import "./obraojs/rem"
export default {
  data () {
    return{
      BiCardNum: '',
      BiCarmHael: '',
      bindfail: 'none',
      bindtips: '',
      bindsucs: 'none',
      loginID: '',
      bistus: '',
      bioler: '',
      biolrd: ''
    }
  },
  created () {
    // 从缓存里获取token
    this.loginID = localStorage.getItem("usertoken");
    // 接收卡包(卡明细)传过来的卡状态
    this.bistus = this.$route.query.castus;
    // 接收卡明细传过来的账号密码
    this.bioler = this.$route.query.deoler;
    this.biolrd = this.$route.query.deolrd;
  },
  mounted () {

  },
  methods: {
    // 获取输入的卡号
    BiCardber(){
      // console.log(this.BiCardNum);
    },
    // 获取输入的密码
    BiCarmChel(){
      // console.log(this.BiCarmHael);
    },
    // 点击确认提交卡的信息
    bindconm(){
      if(this.BiCardNum == ''){
        this.bindtips = '卡号不能为空';
        this.bindfail = 'block';
        const _this = this;
        setTimeout(function(){
          _this.bindfail = 'none';
        },1200)
      }else if(this.BiCarmHael == ''){
        this.bindtips = '卡初始密码不能为空';
        this.bindfail = 'block';
        const _this = this;
        setTimeout(function(){
          _this.bindfail = 'none';
        },1200)
      }else{
        this.$axios.post('app/appParentCard',this.$qs.stringify({
          uptype: this.bistus,
          token: this.loginID,
          cnumber: this.bistus == '5' ?  this.bioler : this.BiCardNum,
          cpassword: this.bistus == '5' ? this.biolrd : this.BiCarmHael,
          ncnumber: this.bistus == '5' ? this.BiCardNum : '',
          ncpassword: this.bistus == '5' ? this.BiCarmHael : ''
        }),{headers:{'Content-Type':'application/x-www-form-urlencoded'}})
        .then(res => {
          if(res.data.code == '200'){
            this.bindtips = res.data.msg;
            this.bindsucs = 'block';
            const _this = this;
            setTimeout(function(){
              _this.BiCardNum = '';
              _this.BiCarmHael = '';
              _this.bindsucs = 'none';
            },1200)
          }else{
            this.bindtips = res.data.msg;
            this.bindfail = 'block';
            const _this = this;
            setTimeout(function(){
              _this.BiCarmHael = '';
              _this.bindfail = 'none';
            },1200)
          }
        })
        .catch(() => {
          console.log('获取失败');
        });
      }
    },
    // 返回上一层
    BackLevel(){
      this.$router.go(-1)
    }
  }
}
</script>

<style scoped>
  @import "obraocs/BindCard.css";
</style>